/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, memo, useState } from "react";
import BackLayout from "./Components/BackLayout";
import ImagesConfig from "components/ImagesConfig";
import HeaderPage from "./Components/HeaderPage";
import { getListGameAction } from "store/actions/GamePageAction";
import { HEIGHT_HEADER } from "config/constant";
import { Grid } from "@material-ui/core";
import { connect } from "react-redux";
import { Images } from "config/images";

const GamePage = memo(props => {
	const { dispatchGetListGame, games } = props;
	const [gameSelected, setGameSelected] = useState("");

	useEffect(() => {
		dispatchGetListGame();
	}, []);

	return gameSelected ? (
		<BackLayout
			onClick={() => {
				setGameSelected("");
			}}
		>
			<iframe
				src={gameSelected}
				width="100%"
				height="100%"
				title={gameSelected}
				frameBorder="0"
			/>
		</BackLayout>
	) : (
		<Grid>
		<HeaderPage/>
			<Grid
				style={{
					height: `calc(100vh - ${HEIGHT_HEADER}px)`,
					overflowY: "scroll"
				}}
			>
				<Grid container spacing={2} style={{ padding: 20 }}>
					{games?.map((game, index) => (
						<Grid item xs={6} key={index}>
							<Grid
								style={{
									background: "#e4d2e3",
									padding: 10,
									borderRadius: 10,
									boxShadow:
										"0 2px 8px 0 rgba(0, 0, 0, 0.07)",
									cursor: "pointer"
								}}
								onClick={() => {
									setGameSelected(game?.url);
								}}
							>
								<Grid style={{ height: 150, width: "100%" }}>
									<ImagesConfig
										image={game?.banner}
										imageDefault={Images.logoNonNoti}
										width={"100%"}
										height={"100%"}
									/>
								</Grid>
								<Grid
									style={{
										color: "#173e58",
										fontWeight: 500,
										padding: "10px 0px",
										textAlign: "center"
									}}
								>
									{game?.name}
								</Grid>
							</Grid>
						</Grid>
					))}
				</Grid>
			</Grid>
		</Grid>
	);
});

const mapStateToProps = state => {
	return {
		games: state.gamePageReducer.games
	};
};

const mapDispatchToProps = dispatch => {
	return {
		dispatchGetListGame: () => {
			dispatch(getListGameAction());
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(GamePage);
